import { render, staticRenderFns } from "./SellerFormModal.vue?vue&type=template&id=ff39146c"
import script from "./SellerFormModal.ts?vue&type=script&lang=ts&external"
export * from "./SellerFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff39146c')) {
      api.createRecord('ff39146c', component.options)
    } else {
      api.reload('ff39146c', component.options)
    }
    module.hot.accept("./SellerFormModal.vue?vue&type=template&id=ff39146c", function () {
      api.rerender('ff39146c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/SellerFormModal.vue"
export default component.exports